import { combineReducers } from 'redux';
import { coreAddTagsSyncSlice } from './add';
import { coreTagsGetAsyncSlice } from './get';
import { coreTagsIdMapReducers } from './_idMap';
import { coreTagsPostAsyncSlice } from './post';
import { coreTagsRemoveSyncSlice } from './remove';
import { coreTagsUpdateSyncSlice } from './update';

import { combineAllWatchers, joinReducers } from '@sonar-software/xuder';
import { coreTagsByIdReducers, coreTagsByIdWatchers } from './_id';
import { coreTagsLinkReducers, coreTagsLinkWatchers } from './link';
import { coreTagsUnlinkReducers, coreTagsUnlinkWatchers } from './unlink';

export const coreTagsReducers = combineReducers({
	byId: coreTagsByIdReducers,
	byIdMap: coreTagsIdMapReducers,
	get: joinReducers(
		[
			coreTagsGetAsyncSlice.asyncReducers,
			coreAddTagsSyncSlice.syncReducer,
			coreTagsRemoveSyncSlice.syncReducer,
			coreTagsUpdateSyncSlice.syncReducer
		],
		coreTagsGetAsyncSlice.asyncState
	),
	link: coreTagsLinkReducers,
	post: coreTagsPostAsyncSlice.asyncReducers,
	unlink: coreTagsUnlinkReducers
});

export const coreTagsWatchers = combineAllWatchers([
	coreTagsByIdWatchers,
	coreTagsGetAsyncSlice.asyncWatchers,
	coreTagsLinkWatchers,
	coreTagsPostAsyncSlice.asyncWatchers,
	coreTagsUnlinkWatchers
]);
